/**
 * 内置多档包组件：invoke / 代理一次返回 current 内各档，勿传 timeDirection / dateRange
 */

export const STORE_INVOKE_BUNDLE_ONLY = new Set([
  'hourly-price-by-room',
  'room-health',
  'occupancy-analysis',
  'order-traffic',
  'channel-info',
  'channel-analysis',
  'revpar',
  'channel-price',
  'discount-analysis',
  'customer-source',
  'operation-efficiency',
]);

export function storeComponentUsesTimeDirection(componentType: string): boolean {
  return !STORE_INVOKE_BUNDLE_ONLY.has(componentType);
}
